
export function request(data, tagId, query = {}, getAll = false) {
    return {
        type: 'ADD_MARKETS_TO_TAG_REQUEST',
        data,
        tagId,
        query,
        getAll
    };
}

export function error(errors) {
    return {
        type: 'ADD_MARKETS_TO_TAG_REQUEST_ERROR',
        errors
    };
}

export function finish(data) {
    return {
        type: 'ADD_MARKETS_TO_TAG_REQUEST_FINISH',
        data
    };
}
